import Table from '../../../form/component/Table'
import { renderStoreNameById } from '../../../store/util/renderStoreName'
import { renderCountryName } from '../../../customer/util/names'


export default (isTablet) => {
    return isTablet ? columnListStore : columnList
}

const columnListStore = [
    {
        property: 'firstName',
        header: 'Firstname',
        columnName: 'firstName',
    },
    {
        property: 'lastName',
        header: 'Lastname',
        columnName: 'lastName',
    },
    {
        property: 'email',
        header: 'Email',
        columnName: 'email',
    },
    {
        property: 'phone',
        header: 'Phone',
        columnName: 'phone',
    },
    {
        property: 'startTime',
        header: 'Starttime',
        renderer: Table.dateTimeRenderer('startTime'),
        columnName: 'startTime',
    },
    {
        property: 'appointmentType',
        header: 'Appointment Type',
        columnName: 'appointmentType',
    },
    {
        property: 'status',
        header: 'Status',
        columnName: 'status',
    },
    {
        property: 'cancelCategory',
        header: 'Cancel Category',
        columnName: 'cancelCategory',
    },
]

const columnList = [
    {
        property: 'created',
        header: 'Created',
        renderer: Table.dateTimeRenderer('created'),
        columnName: 'created',
    },
    {
        property: 'updated',
        header: 'Updated',
        renderer: Table.dateTimeRenderer('updated'),
        columnName: 'updated',
    },
    {
        property: 'firstName',
        header: 'Firstname',
        columnName: 'firstName',
    },
    {
        property: 'lastName',
        header: 'Lastname',
        columnName: 'lastName',
    },
    {
        property: 'email',
        header: 'Email',
        columnName: 'appointment_appointment.email',
    },
    {
        property: 'storeId',
        header: 'Store',
        renderer: (appointment) => {
            return renderStoreNameById(appointment.storeId)
        },
        columnName: 'storeId',
    },
    {
        property: 'phone',
        header: 'Phone',
        columnName: 'phone',
    },
    {
        property: 'startTime',
        header: 'Starttime',
        renderer: Table.dateTimeRenderer('startTime'),
        columnName: 'startTime',
    },
    {
        property: 'endTime',
        header: 'Endtime',
        renderer: Table.dateTimeRenderer('endTime'),
        columnName: 'endTime',
    },
    {
        property: 'appointmentType',
        header: 'Appointment Type',
        columnName: 'appointmentType',
    },
    {
        property: 'status',
        header: 'Status',
        columnName: 'status',
    },
    {
        property: 'cancelCategory',
        header: 'Cancel Category',
        columnName: 'cancelCategory',
    },
    {
        property: 'countryCode',
        header: 'Country',
        renderer: (appointment) => {
            return renderCountryName(appointment.countryCode)
        },
        columnName: 'appointment_appointment.countryCode',
    },
]



// WEBPACK FOOTER //
// ./src/modules/appointment/component/search/appointment-column-list.js